import React from 'react';

import XMarkIcon from 'Assets/icons/xmark.svg';

const MAX_VISIBLE_CHIPS = 4;

/**
 * A removable chip per selected project. `limit` caps the chips shown, the
 * rest summarised as "+N more"; null shows every one.
 */
export default function SelectedProjectsStrip({ selectedEvents, onRemove, showCurrency = false, limit = MAX_VISIBLE_CHIPS }) {
    if (!selectedEvents.length) {
        return null;
    }

    const visible = limit === null ? selectedEvents : selectedEvents.slice(0, limit);
    const overflow = selectedEvents.length - visible.length;

    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-mb-4">
            {visible.map((event) => (
                <span
                    key={event.id}
                    className="tw-inline-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-bg-blue-10 tw-text-blue"
                >
                    {event.name}
                    {showCurrency && event.currency?.code && <span className="tw-font-normal tw-text-blue-75">{event.currency.code}</span>}
                    <button
                        type="button"
                        aria-label={$t('Remove {{name}}', { name: event.name })}
                        onClick={() => onRemove(event.id)}
                        className="tw-inline-flex tw-items-center tw-justify-center"
                    >
                        <XMarkIcon className="tw-w-3 tw-h-3" />
                    </button>
                </span>
            ))}
            {overflow > 0 && (
                <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-bg-charcoal-10 tw-text-charcoal-75">
                    {$t('+{{count}} more', { count: overflow })}
                </span>
            )}
        </div>
    );
}
